import { render, staticRenderFns } from "./LibraryCard.vue?vue&type=template&id=23d4b670&scoped=true"
import script from "./LibraryCard.vue?vue&type=script&lang=js"
export * from "./LibraryCard.vue?vue&type=script&lang=js"
import style0 from "./LibraryCard.vue?vue&type=style&index=0&id=23d4b670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d4b670",
  null
  
)

export default component.exports